import React from 'react';
import {
  DetailsBg,
  DetailsContent,
  DetailsContentAdditional,
  DetailsContentMain,
} from './CrawfordsFarmDetails.style.pn';

export interface CrawfordsFarmDetailsProps {
  locationDetails: React.ReactNode;
  contactDetails: React.ReactNode;
}

const CrawfordsFarmDetails: React.FC<CrawfordsFarmDetailsProps> = ({ locationDetails, contactDetails }) => {
  return (
    <DetailsBg data-testid="crawfords-farm-details">
      <DetailsContent>
        <DetailsContentMain>{locationDetails}</DetailsContentMain>
        <DetailsContentAdditional>{contactDetails}</DetailsContentAdditional>
      </DetailsContent>
    </DetailsBg>
  );
};

export default CrawfordsFarmDetails;
